import { render, staticRenderFns } from "./Expense.vue?vue&type=template&id=08dd00f8&scoped=true&"
import script from "./Expense.vue?vue&type=script&lang=ts&"
export * from "./Expense.vue?vue&type=script&lang=ts&"
import style0 from "./Expense.vue?vue&type=style&index=0&id=08dd00f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dd00f8",
  null
  
)

export default component.exports